import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getIndividualProductsQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';
import { chassis } from '@/utils';

export const loaderUnitSpecificationsPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // First fetch the unit data
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  // Extract serial numbers from the unit data
  const serialNumbers = chassis.getUnitSerialNumbers(unitData);

  // Prefetch products data if we have serial numbers
  if (serialNumbers.length > 0) {
    await opts.context.queryClient.ensureQueryData(getIndividualProductsQueryOptions({ serialNumbers }));
  }

  return { endCustomerUnitId };
};
